import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { loginSuccess } from '../../store/login';
import { editFormInput, getInputData } from '../../store/forms';
import useMdUpScreen from '../../hooks/useMdUpScreen';
import { getReserve } from '../../api/endpoints';
import useApi from '../../api/hooks/useApi';
import { setReserveData } from '../../store/reserve';
import { addError } from '../../store/errors';
import useLoginValidation from '../../hooks/validations/useLoginValidation';
import { useLayoutParameters } from '../../hooks/useLayoutParameters';
import { componerConfiguracion } from '../../store/selectors';


import LoginView from './View';

function CheckInLogin() {
  const ref= useRef(null);
  
  const selectViewConfig = useMemo(componerConfiguracion, []);
  const viewParameters = useSelector(state => selectViewConfig(state, 'CheckInLogin'));
  const [buttonPressed, setButtonPressed] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const mdUpScreen = useMdUpScreen();

  const view = "login";
  const object = "checkinLogin";
  const reservationNumber = useSelector(getInputData(view, object, "reservationNumber"));
  const authorizationCode = useSelector(getInputData(view, object, "authorizationCode"));
  const dispatchChange = (id, data) => {
    // console.log(event.target.value);
    dispatch(editFormInput({ data, object, input: id, view }));
  };
  const handleChange = (id, event) => {
    // console.log(event.target.value);
    dispatchChange(id, event.target.value);
  };
  const [apiParams, setApiParams] = useState(null);
  const apiResponse = useApi(apiParams);

  const [error, setError] = useState('');

  const validForm = useLoginValidation(true);
  useEffect(() => {
    if (apiResponse) {
      console.log('apiResponse',apiResponse);
      if(apiResponse.success === true && apiResponse.response.data.data !== null && apiResponse.response.data.data.length > 0){
          console.log('lastCall', apiResponse);
          const responseData = apiResponse.response.data;
          const { success, data } = responseData;
          if (success) {
            const reserve = data[0];
            dispatch(loginSuccess(reserve));
            dispatch(setReserveData(reserve));
            setLoading(false);
            const { trv_chk_tyc, trv_chk_dtv } = reserve;
            const redirect = trv_chk_tyc === '1' && trv_chk_dtv === '1' ? '/finish' : '/step-1'; 
            navigate(redirect);
            setApiParams(null);
            dispatchChange('authorizationCode', '');
          } else {
            const response = data[0];
            const { tmp_msj_api, tmp_tip_msj } = response;
            setError(tmp_msj_api);
            setLoading(false);
            setTimeout(() => setError(''), 7000);
            dispatch(addError(apiResponse));
            if(tmp_tip_msj === 'errorPswd'){
              dispatchChange('authorizationCode', '');
            }

            if(tmp_tip_msj === 'noReserva' || tmp_tip_msj === 'otro'){
              dispatchChange('reservationNumber', '');
              dispatchChange('authorizationCode', '');
            }
            setButtonPressed(false);
          }
      }else if(apiResponse.response.data.data === null || apiResponse.response.data.data.length === 0){
        setError(`No hay datos en la respuesta de ${getReserve}`);
        setLoading(false);
        setTimeout(() => setError(''), 7000);
        dispatch(addError(apiResponse));
      }else{
        setError(`Ha habido un problema con el servicio ${getReserve}`);
        setLoading(false);
        setTimeout(() => setError(''), 7000);
        dispatch(addError(apiResponse));
        dispatchChange('authorizationCode', '');
      }
    }
  }, [apiResponse]); // eslint-disable-line react-hooks/exhaustive-deps


  const handleLogin = (e) => {
    e.preventDefault();
    setButtonPressed(true);
    if (validForm) {
      const dataVector = [reservationNumber.data, authorizationCode.data];
      setApiParams({ apiPath: getReserve, dataVector });
      setLoading(true);
    }
  };

  return (
    <LoginView viewParameters={viewParameters} error={error} handleChange={handleChange} handleLogin={handleLogin} mdUpScreen={mdUpScreen} loading={loading} buttonPressed={buttonPressed} templateRef={ref} />
  );
}

export default CheckInLogin;